import { makeStyles, shorthands } from "@fluentui/react-components";
export const useStyles = makeStyles({
  root: {
    display: "flex",
    justifyContent: "space-between",
    fontFamily: "Segoe UI",
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "16px",
    lineHeight: "22px",
    ...shorthands.gap("30px"),

    "@media (max-width: 540px)": {
      flexWrap: "wrap",
    },
  },

  carousel: {
    width: "unset",
    paddingRight: "8px",
    paddingLeft: "8px",
  },
});
